<template>
    <div style="background: #f4f4f4; width: 100%; height: 100%; position: relative">
        <loginHeader />
        <div class="login_root_box">
            <div class="login_center_box" style="position: relative">
                <img
                @click="gotourl"
                    src="../assets/htgl1.png"
                    style="
            position: absolute;
            width: 92px;
            height: 90px;
            right: 0; 
            top: 0; 
          "
                    alt=""
                />
                <div class="login_box_title">手机短信登录/注册</div>
                <div
                    style="
            overflow: hidden;
            width: 340px;
            height: 48px;
            margin: 30px auto;
          "
                >
                    <div class="quhao">+86</div>
                    <input type="text" v-model="tel" class="input" name="" placeholder="手机号码" id="" />
                </div>
                <div
                    style="
            overflow: hidden;
            width: 340px;
            height: 48px;
            margin: 30px auto;
          "
                >
                    <div v-if="yzm_code" class="yzm_but" style="cursor: pointer" @click="sendCode">
                        {{ yzm_txt }}
                    </div>
                    <div v-else class="yzm_but" style="cursor: pointer;background: #BFBFBF;color: #fff;">
                        {{ yzm_txt }}
                    </div>
                    <input type="text" class="input" style="width: 60%" name="" placeholder="短信验证码" id="" v-model="yzm" />
                </div>
                <div class="login_but" style="cursor: pointer" @click="registerFun">
                    登录
                </div>
                <div style="width: 340px; margin: 20px auto; overflow: hidden;">
                    <a-checkbox style="float: left;">
                        <span class="zidongdenglu">下次自动登录</span>
                    </a-checkbox>
                    <router-link to="/wangjimima"><span class="wangjimima">忘记密码 ?</span></router-link>
                </div>
                <router-link to="/login"><div class="duanxindenglu">用户名密码登录</div></router-link>
                <div style="width: 60%; margin: 20px auto; overflow: hidden">
                    <a-divider class="qitafangshi_txt">其他方式</a-divider>
                </div>
                <div style="width: 15%; margin: 20px auto; overflow: hidden">
                    <a href=""><img src="../assets/login_qq.png" style="float: left; width: 38px; height: 38px" alt=""/></a>
                    <a href=""><img src="../assets/login_wx.png" style="float: right; width: 38px; height: 38px" alt=""/></a>
                </div>
            </div>
        </div>

        <loginFoot />
    </div>
</template>

<script>
import axios from 'axios';
import loginHeader from '../public/login_head';
import loginFoot from '../public/login_foot';
export default {
    name: 'integral',
    components: {
        loginHeader,
        loginFoot
    },
    data() {
        return {
            tel: '',
            yzm: '',
            yzm_txt: '获取验证码',
            count: 0,
            yzm_code: true
        };
    },
    methods: {
        gotourl(){
        //alert(11)
        this.$router.push("/login_m")
    },
        // 发送验证码
        sendCode() {
            if (!this.tel) return this.$message.error('请输入手机号');
            if (!/^1\d{10}$/.test(this.tel)) return this.$message.error('手机号格式不正确');
            this.api.get_verifycode(this.tel).then(res => {
                if (res.ok) {
                    this.yzm_code = false;
                    this.countdown(60);
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 倒计时
        countdown(count) {
            setTimeout(() => {
                count -= 1;
                if (count) {
                    this.yzm_txt = count + 's后重新获取';
                    this.countdown(count);
                } else {
                    this.yzm_txt = '重新获取';
                    this.yzm_code = true;
                }
            }, 1000);
        },

        // 登录
        signIn() {},
        // 注册
        registerFun() {
            this.api
                .code_login({
                    data: { mobile: this.tel, code: this.yzm },
                    realm: 'system',
                    type: 'mobile_code'
                })
                .then(res => {
                    if (res.ok) {
                        // localStorage.token = res.data.token
                        localStorage.setItem('Access-Token', res.data.token);
                        localStorage.user_info = JSON.stringify(res.data.user);
                        localStorage.username = res.data.user.username;
                        localStorage.uuid = res.data.user.uuid;
                        this.$message.success('登录成功');
                        this.$router.push('/');
                    } else {
                        this.$message.error(res.message);
                    }
                });
        }
    },
    created() {
        // /api/user/register/public
        // this.registerFun();
    }
};
</script>

<style scoped>
.yzm_but {
    width: 40%;
    height: 100%;
    float: right;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
    line-height: 48px;
    border: 1px solid #ede9e9;
    border-left: none;
}

.quhao {
    width: 20%;
    height: 100%;
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 48px;
    border: 1px solid #ede9e9;
    border-right: none;
}

.qitafangshi_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}

.duanxindenglu {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
}

.wangjimima {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    float: right;
}

.zidongdenglu {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.login_but {
    width: 340px;
    height: 48px;
    background: #2b9a34;
    text-align: center;
    line-height: 48px;
    margin: 20px auto;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}

.input {
    width: 80%;
    height: 100%;
    float: left;
    border: 1px solid #ede9e9;
    display: block;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    padding-left: 10px;
    outline: none;
}

.login_box_title {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    text-align: center;
}

.login_root_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login_center_box {
    width: 800px;
    height: 520px;
    background: #ffffff;
}

html,
body,
#app {
    background: #f4f4f4 !important;
}

.bottom_nav_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    width: 20%;
    float: left;
}

.top_title1 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    float: left;
    margin-left: 2%;
}

.login_lianxifangshi {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
}
</style>



// WEBPACK FOOTER //
// src/components/code_login.vue